import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTenant } from "../../../redux/roles/rolesSlice";
import { updateRole } from "../../../redux/roles/rolesSlice";
import PermissionItem from "./PermissionItem";
import CustomButton from "../../../Components/Common/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../Components/Common/Loading";
import toast from "react-hot-toast";

const PractitionerPermission = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()
  const roleId = new URLSearchParams(location.search).get("role_id");
  const { tenant, loading, error } = useSelector((state) => state.tenant);
  const [permissions, setPermissions] = useState([]);
  const [roleState, setRoleState] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    dispatch(getTenant());
  }, [dispatch]);


  useEffect(() => {
    dispatch(getTenant());
  }, [dispatch]);

  useEffect(() => {
    if (tenant?.roles?.length > 0) {
      const roleToUpdate = tenant.roles.find(
        (role) => String(role._id) === roleId
      );
      if (roleToUpdate) {
        const rolePermissions = roleToUpdate.allowedAppsActions[0]?.permissions || {};
        setRoleState(rolePermissions);
        const permissionsArray = Object.keys(rolePermissions).map((name) => ({
          name,
          actions: [
            rolePermissions[name]?.read && "read",
            rolePermissions[name]?.write && "write",
            rolePermissions[name]?.delete && "delete",
          ].filter(Boolean),
        }));
        setPermissions(permissionsArray);
      }
    }
  }, [tenant, roleId]);

  const handleCancel = () => {
    navigate('/iam/roles');
  };

  useEffect(() => {
    dispatch(getTenant());
  }, [dispatch]);

  useEffect(() => {
    if (tenant.permissions) {
      const updatedPermissions = permissions.map((perm) => {
        const matchedPerm = tenant.permissions.find(
          (p) => p.name === perm.name
        );
        return matchedPerm ? { ...perm, actions: matchedPerm.actions } : perm;
      });
      setPermissions(updatedPermissions);
    }
  }, [tenant]);

  const handleActionChange = (name, action) => {
    let updatePermision = { ...roleState[name] };

    if (action === "write") {
      if (!updatePermision.write) {
        updatePermision = {
          write: true,
          read: true,
          delete: updatePermision.delete,
        };
      
      } else {
        updatePermision = { ...updatePermision, write: false };
      }
    } else if (action === "read") {
      if (!updatePermision.read) {
        updatePermision = { ...updatePermision, read: true };
      } else {
        updatePermision = {
          read: false,
          write: false,
          delete: false,
        };
      }
    } else if (action === "delete") {
      if (!updatePermision.delete) {
        updatePermision = {
          ...updatePermision,
          delete: true,
          write: true,
          read: true,
        };
      } else {
        updatePermision = { ...updatePermision, delete: false };
      }
    } else {
      updatePermision[action] = !updatePermision[action];
      
    }

    setRoleState((prev) => ({ ...prev, [name]: updatePermision }));

    // setPermissions((prevPermissions) =>
    //   prevPermissions.map((permission) => {
    //     if (permission.name === name) {
    //       const updatedActions = new Set(permission.actions);
    //       if (action === "write") {
    //         if (!updatedActions.has("write")) {
    //           updatedActions.add("write");
    //           updatedActions.add("read");
    //         } else {
    //           updatedActions.delete("write");
    //         }
    //       } else {
    //         if (updatedActions.has(action)) {
    //           updatedActions.delete(action);
    //         } else {
    //           updatedActions.add(action);
    //         }
    //       }
    //       return { ...permission, actions: Array.from(updatedActions) };
    //     }
    //     return permission;
    //   })
    // );
    setPermissions((prevPermissions) =>
      prevPermissions.map((permission) => {
        if (permission.name === name) {
          const updatedActions = [];
          if (updatePermision.read) updatedActions.push("read");
          if (updatePermision.write) updatedActions.push("write");
          if (updatePermision.delete) updatedActions.push("delete");

          return { ...permission, actions: updatedActions };
        }
        return permission;
      })
    );
  };

  const handleSave = async () => {
    setSaving(true);

    const roleToUpdate = tenant.roles.find(
      (role) => String(role._id) === roleId
    );

    if (roleToUpdate) {
      const updatedAllowedAppsActions = roleToUpdate.allowedAppsActions.map(
        (app) => {
          if (app.appName === "PractitionerApp") {
            return {
              ...app,
              permissions: roleState,
            };
          }
          return app;
        }
      );

      const data = {
        ...roleToUpdate,
        allowedAppsActions: updatedAllowedAppsActions,
      };

   

      try {
        const response = await dispatch(
          updateRole({ tenantId: tenant._id, roleId, data })
        );
        await new Promise((resolve) => setTimeout(resolve, 500));

        await dispatch(getTenant());
        toast("Role updated successfully!");
      } catch (error) {
        toast.error("Failed to update role:", error);
      } finally {
        setSaving(false);
      }
    } else {
      toast.error("Role not found");
    }
  };

  if (loading || saving) {
    return (
      <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50">
        <Loading size="12" color="brand-500" />
      </div>
    );
  }

  if (error === "failed") {
    return toast.error(error);
  }

  return (
    <div className="flex flex-grow bg-gray-100">
      <div
        className="flex-grow p-6 overflow-y-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden "
        style={{ maxHeight: "calc(100vh - 180px)" }}
      >
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg">
          <div className="overflow-x-auto whitespace-nowrap p-4">
            <div className="space-y-6">
              {permissions.map((permission) => (
                <div key={permission.name}>
                  {permission.name === "Profile Management" ||
                  permission.name === "Health Records" ? (
                    <h2 className="font-semibold text-lg">{permission.name}</h2>
                  ) : (
                    <PermissionItem
                      name={permission.name}
                      actions={permission.actions}
                      onActionChange={handleActionChange}
                      roleState={roleState}
                    />
                  )}
                </div>
              ))}
            </div>
            <div className="sticky bottom-0 bg-white p-4 border-t border-gray-200">
              <div className="flex justify-center space-x-6">
                <button
                  onClick={handleSave}
                  className="px-4 pb-1 pt-[2px] text-[16px] bg-brand-500 text-white hover:bg-brand-600 transition duration-300 ease-in-out rounded"
                >
                  {saving ? <Loading size="6" color="white" /> : "Save"}
                </button>
                <CustomButton text="Cancel" onClick={handleCancel} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PractitionerPermission;
